// extracted by mini-css-extract-plugin
export default {"wrap":"Finish_wrap__1+Lvs","title":"Finish_title__Zi+dM","info":"Finish_info__gdkR1"};